<template>
  <div class="feedBackUpload">
    <van-form @submit="onSubmit">
      <div class="feedBack_textarea">
        <van-field
          v-model="content"
          rows="6"
          autosize
          maxlength="300"
          type="textarea"
          show-word-limit
          placeholder="欢迎您提出宝贵的建议"
        />
      </div>
      <div class="feedBack_imgUpload">
        <van-uploader
          v-model="imgList"
          :before-read="beforeReadCredit"
          :before-delete="beforeDetaleCredit"
        />
      </div>
      <div style="margin: 1.5rem 0.3rem 0.2rem;border-radius: 0.1rem;overflow: hidden;">
        <van-button
          square
          block
          size="large"
          type="info"
          :color="btnBgColor"
          native-type="submit"
        >提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { uploadImg } from "@/api/public";
import { photoCompress } from "@/utils/photoCompress";
import { feedbackSeed } from "@/api/work/mine/feedback.js";
export default {
  name: "feedBackUpload",
  data() {
    return {
      content: "",//建议
      imgList: []
    };
  },
  computed: {
    btnBgColor() {
      if (!this.content || this.imgList.length === 0) {
        return "#B3B3B3";
      } else {
        return "#31B158";
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    //上传之前
    beforeReadCredit(file, index) {
      this.$toast.loading({
        message: "上传中...",
        duration: 0,
        forbidClick: true
      });
      //图片上传
      photoCompress(file, res => {
        file = res;
        let fd = new FormData();
        fd.append("file[]", file);
        uploadImg(fd)
          .then(res => {
            this.$toast.clear();
            if (res.code == 200) {
              this.imgList.push({
                url: res.data.resultInfo[0],
                isImage: true
              });
              return true;
            } else {
              return false;
            }
          })
          .catch(err => {
            this.$toast.clear();
            this.$toast.fail("上传失败");
            return false;
          });
      });
    },
    /**
     * 删除图片
     */
    beforeDetaleCredit(file, index) {
      return true;
    },
    // 提交信息
    onSubmit() {
      if (!this.content) {
        this.$toast("请选择填写意见反馈！");
        return false;
      }
      if (!this.imgList.length) {
        this.$toast("请选择上传图片！");
        return false;
      }
      let imgList = [];
      for (let i = 0; i < this.imgList.length; i++) {
        imgList[i] = this.imgList[i].url;
      };

      feedbackSeed({
        img: imgList,
        content: this.content
      }).then(res => {
        if (res.code == 200) {
          this.$toast.success(res.message);
          this.$router.go(-1);
        }
      });
    }
  }
};
</script>
<style lang="less">
.feedBackUpload .van-cell {
  width: 6.9rem;
  background: rgba(244, 245, 250, 1);
  border-radius: 0.1rem;
  margin: 0 auto;
  font-size: 0.32rem;
  font-weight: 500;
  color: rgba(204, 204, 204, 1);
  padding-top: 0.3rem;
  padding-right: 0.3rem;
  padding-left: 0.3rem;

  .van-field__word-limit {
    font-size: 0.24rem;
    font-weight: 500;
    color: rgba(204, 204, 204, 1);
    background: rgba(244, 245, 250, 1);
    .van-field__word-num::before {
      content: "(";
      font-size: 0.24rem;
    }
  }
  .van-field__word-limit::after {
    content: ")";
    font-size: 0.24rem;
  }
}
</style>

<style lang="less" scoped>
.feedBackUpload {
  position: relative;
  width: 7.5rem;
  .feedBack_textarea {
    background: #fff;
    padding-top: 0.2rem;
    padding-bottom: 0.3rem;
  }
  .feedBack_imgUpload {
    background: #fff;
    padding: 0 0 0.41rem 0.3rem;
  }
}
</style>